import { object, string, number, array ,date, InferType } from 'yup';

const UserInfoScheme = object({
    FirstName: string().required(),
    LastName: string().required(),
    email: string().email().required(),
    description: string().required()
})

export default UserInfoScheme